import PrintPreviousReplies from '../pages/print-previous-replies';
import PrintReviewTicket from '../pages/print-review-ticket';
import LawsuitRequest from '../pages/index';
import LawsuitPartyAuthentications from '@/modules/lawsuit/pages/lawsuit-party-authentications';
import JudgementDeedsInquiry from '../pages/judgement-deeds-inquiry.vue';
import ar from '@/local/ar.js';

export default [
  {
    path: '/lawsuit-requests/:objectKey/party-authentications',
    name: 'party-authentications',
    component: LawsuitPartyAuthentications,
    meta: { noBreadcrumbs: true },
  },
  {
    path: '/lawsuit-requests',
    name: 'lawsuit-requests',
    component: LawsuitRequest,
    meta: {
      breadcrumbs: {
        text: ar.breadcrumbs.lawsuitRequests,
        isDynamic: false,
      },
    },
    children: [
      {
        path: ':objectKey/:step',
        name: 'edit-lawsuit-requests-with-step',
        component: LawsuitRequest,
      },
      {
        path: ':objectKey',
        name: 'edit-lawsuit-requests',
        component: LawsuitRequest,
      },
    ],
  },
  {
    path: '/lawsuit-requests/:objectKey/previous-replies/print',
    name: 'print-previous-replies',
    component: PrintPreviousReplies,
    meta: { noBreadcrumbs: true },
  },
  {
    path: '/lawsuit-requests/:objectKey/review-ticket/print',
    name: 'print-review-ticket',
    component: PrintReviewTicket,
    meta: { noBreadcrumbs: true },
  },
  {
    path: '/judgement-inquiry',
    name: 'judgement-deeds-inquiry',
    component: JudgementDeedsInquiry,
    meta: { noBreadcrumbs: true, isPublic: true },
  },
];
